<template>

    <div class="colores">

        <h6 v-if="tipo=='entradas'">Color de fondo</h6>
        <h6 v-if="tipo=='pulseras'">Tipo pulsera y fondo</h6>
        <b-form-row class="justify-content-md-center" cols="2" v-if="tipo=='entradas'">
            <b-col v-for="item in colores">
                <b-button block variant="outline-dark" size="sm" v-on:click="$emit('CambiaFondo', setValor(item.imagen));">{{item.nombre}}</b-button>
            </b-col>

        </b-form-row>
        <b-form-row class="justify-content-md-center" cols="2" v-if="tipo=='pulseras'">
            <b-form-radio-group :options="tipopulsera" v-model="pulsera" v-model.lazy="pulsera"
                                size="sm" style="font-size:12px"></b-form-radio-group>

            <b-form-select size="sm" :options="selectPulsera" v-model="color" @change="onChange($event)"></b-form-select>


        </b-form-row>
        <div v-if="setTipo"></div>
    </div>

</template>

<script>
    import axios from 'axios'
    export default {
        props: {
            tipo: String
        },
        data: function () {
            return {
                tipopulsera: [],
                colores: [],
                pulsera: 'tyvek',
                color: '',
                precios:[],

            }
        },
     
        computed: {
            setTipo: {
                get: function () {
                    if (this.tipo == 'pulseras') { this.obtenerTipoPulseras(); }
                    if (this.tipo == 'entradas') { this.obtenerColores(); }
                    return false;
                }
            },
            selectPulsera: {
                // getter
                get: function () {
                    let aux = this.tipopulsera.filter(x => x.value == this.pulsera);
                   
                    let result = [];

                    let v_precios = [];
                 
                    let v_color = '';
                    if (aux.length > 0) {

                        result = aux[0].colores;
                        v_color = result[0].value
                        v_precios = aux[0].precios;
                    }
                    this.color = v_color;
                 
                    let valores = new Object();
                    valores.name = v_color;
                    valores.colores = this.setColoresCantidades(result);
                    valores.precios = v_precios;                    
                    this.$emit('setImagenDefault', valores);               
                    return result;
                },


            }
        },
        methods: {
            setValor (imagen) {
                let valores = new Object();
                valores.name = imagen;               
                valores.colores =this.getColoresCantidades();
                valores.precios = this.precios;
                return valores;
            },
            setColoresCantidades(datos) {
                   let colors = [];
                let cantidades = [];
               
                colors = datos; 
          
                for (var i = 0; i < colors.length; i++) {
                   
                    var color = new Object();
                    if (this.tipo == "entradas") { color.color = colors[i].nombre; }
                    if (this.tipo == "pulseras") {
                        color.color = colors[i].text;
            }
                    
                    color.cantidad = 0;
                    cantidades.push(color);
                }
             
                return cantidades;
            },
            getColoresCantidades () {
                let colors = [];
                let cantidades = [];
                if (this.tipo == "entradas") {
                  
                    colors = this.colores;
                }
                if (this.tipo == "pulseras") { colors = this.selectPulsera; }
               
                for (var i = 0; i < colors.length; i++) {
                   
                    var color = new Object();
                    if (this.tipo == "entradas") { color.color = colors[i].nombre; }
                    if (this.tipo == "pulseras") {   color.color = colors[i].text;   }
                    
                    color.cantidad = 0;
                    cantidades.push(color);
                }
              
                return cantidades;

            },
            onChange(event) {
                 this.color = event;                
                 let valores = new Object();
                 valores.name = event;
                 valores.colores = this.getColoresCantidades();
                let aux = this.tipopulsera.filter(x => x.value == this.pulsera);
                valores.precios = aux['precios'];
                
                this.$emit('CambiaFondo', valores);


            },
            obtenerTipoPulseras() {
                this.tipopulsera = [];
                axios.get(process.env.VUE_APP_BASE_JSON).then(response => {
                   
                    let auxpulseras = response.data.pulseras.colores;
                    for (var key in auxpulseras) {
                        var tipo_color = new Object();
                        tipo_color.text = key;
                        tipo_color.value = key;
                        tipo_color.colores = [];
                   
                        tipo_color.precios = response.data.pulseras.precios[key];
                        this.precios = tipo_color.precios;

                        var aux_colores = auxpulseras[key].filter(t => t.stock == 'true');
                        for (var key2 in aux_colores) {
                            var color = new Object();
                            color.text = aux_colores[key2].nombre;
                            color.value = key + '/' + aux_colores[key2].imagen;

                            tipo_color.colores.push(color);
                        }
                       

                        this.tipopulsera.push(tipo_color);
                    }

                })
                    .catch(e => { console.log(e.response) })

            },
            obtenerColores() {
                this.colores = [];
                axios.get(process.env.VUE_APP_BASE_JSON).then(response => {
                 
                    let aux = response.data[this.tipo].colores.filter(t => t.stock == 'true');
                    this.colores = aux;                  
                    this.color = aux[0].imagen;
                    this.precios= response.data[this.tipo].precios;
                    let valores = new Object();                    
                    valores.name = this.color;                    
                    valores.colores = this.setColoresCantidades(this.colores);  
                    valores.precios = response.data[this.tipo].precios;
                    this.$emit('setImagenDefault', valores);
                })
                    .catch(e => { console.log(e.response) });

            }
        }



    };
</script>

<style lang="scss">
</style>